// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1o-2";
export var blackBorderOnHover = "_1o-7";
export var cell = "_1o-6";
export var cellContainer = "_1o-3";
export var checked = "_1o-8";
export var disabled = "_1o-5";
export var featuredIconCellContainer = "_1o-9";
export var featuredIconTextContainer = "_1o-b";
export var featuredIconWrapper = "_1o-a";
export var noBorder = "_1o-c";
export var orangeSelectedRow = "_4k-3";
export var overflowableText = "_1o-0";
export var overflowableTextContainer = "_1o-1";
export var row = "_1n-0";
export var rowCheckboxCell = "_1o-4";
export var selectableTable = "_4k-2";